
import React from 'react';
import S3Image from './S3Image';
import Box from '@mui/material/Box';
import Dialog from '@mui/material/Dialog';
import ImageSelection from './ImageSelection';


function SelectableImage({ deviceID, deviceTypeID, boardID, src, boardHeight, sx, width, height, scale, tick, onImageChange }) {

    const [open, setOpen] = React.useState(false);
    const [imageSrc, setImageSrc] = React.useState(src);

    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = (newSrc) => {
        setOpen(false);
        if (newSrc && newSrc !== imageSrc) {
            onImageChange?.();
            setTimeout(() => {
            setImageSrc(newSrc);
            }, 1000);
            return;
        }
        setImageSrc(newSrc);
    };

    return (
        <Box>
            <S3Image
                src={imageSrc}
                scale={scale}
                boardHeight={boardHeight}
                sx={sx}
                onClick={handleClickOpen}
                tick={tick}
            />
            <Dialog
                open={open}
                onClose={handleClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                fullWidth
                maxWidth="sm"
            >
                {
                    <ImageSelection
                        deviceID={deviceID}
                        deviceTypeID={deviceTypeID}
                        boardID={boardID}
                        boardHeight={boardHeight}
                        handleClose={handleClose}
                        sx={{
                            width: width,
                            height: height,
                            display: 'inline-block',
                            position: 'absolute',
                            marginLeft: 0,
                            marginTop: 0,
                        }}
                    />
                }
            </Dialog>

        </Box>
    );
}
export default SelectableImage;